import { useForm } from "react-hook-form";
import { DefaultFormMultiAutocomplete } from "../../../../../../common/components/default_form_multi_autocomplete";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";

import FormContainer from "../../../../../../common/components/form_container";
import {
  ObrasMateriaisControladosForm,
  ObrasMateriaisControladosSchema,
} from "../../../schemas/Obras_ObrasMateriaisControlados/Obras_ObrasMateriaisControlados";
import { GetObraMateriaisControladosDropDown } from "../../../../data/daos/read/get_obra_materiais_controlados_dropdown";

/**
 * ObrasMateriaisControladosModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  materiaisControlados: GetObraMateriaisControladosDropDown[];
  onClose: () => void;
  onSubmit: (form: ObrasMateriaisControladosForm) => void;
};

export const ObrasMateriaisControladosModal = ({ open, saving, loading, materiaisControlados, onClose, onSubmit }: Props) => {
  const hookForm = useForm<ObrasMateriaisControladosForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: zodResolver(ObrasMateriaisControladosSchema),
  });

  useEffect(() => {
    if (open) {
      hookForm.reset();
    }
  }, [open, hookForm]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      width="50rem"
      title="Incluir Materiais Controlados"
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}
    >
      <FormContainer title="Informações" arrangement="fullRow">
        <>
          <DefaultFormMultiAutocomplete
            name="idMateriaisControlados"
            label="Materiais Controlados"
            options={materiaisControlados}
            getOptionKey={(x) => x.idMateriaisControlados}
            getOptionLabel={(x) => x.materiaisControlados ?? ""}
            reactHookForm={hookForm}
          />
        </>
      </FormContainer>
    </BaseFormControlledModal>
  );
};
